import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, TrendingUp, BarChart3, GitBranch, Users, Handshake, Megaphone, ClipboardList, CalendarHeart } from 'lucide-react';
export function ProfessionalComparison() {
  const comparisons = [{
    situation: 'Reunión técnica con equipo de desarrollo BR',
    without: 'Perdés los términos técnicos',
    with: 'Vocabulario completo de IT en PT'
  }, {
    situation: 'Propuesta comercial a empresa brasileña',
    without: 'No sabés cómo sonar profesional',
    with: 'Templates listos para usar'
  }, {
    situation: 'Reporte financiero o P&L en PT',
    without: 'Solo manejás números básicos',
    with: 'DRE, EBITDA y sistema tributario BR'
  }, {
    situation: 'Brasileño que esquiva sin decir que no',
    without: 'Creés que hay interés',
    with: 'Entendés las señales reales'
  }, {
    situation: 'LinkedIn con profesionales brasileños',
    without: 'Podés escribir pero sin estrategia',
    with: 'Scripts de conexión y follow-up listos'
  }];
  const modules = [{
    icon: <TrendingUp className="w-6 h-6" data-id="element-234" />,
    title: 'Portugués para IT y Tecnología',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-500/20',
    items: 'Vocabulario de desarrollo, metodologías ágiles, reuniones diarias, reportes de bugs y comunicación técnica con equipos de Brasil.'
  }, {
    icon: <BarChart3 className="w-6 h-6" data-id="element-235" />,
    title: 'Portugués para Marketing Digital',
    color: 'text-green-300',
    bgColor: 'bg-green-500/20',
    items: 'Términos de campañas, métricas, redes sociales, SEO, y cómo presentar resultados a clientes o agencias brasileñas.'
  }, {
    icon: <Handshake className="w-6 h-6" data-id="element-236" />,
    title: 'Portugués para Finanzas y Negocios',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-500/20',
    items: 'Lectura de reportes financieros, DRE, sistema tributario básico brasileño, y vocabulario para negociaciones y contratos.'
  }, {
    icon: <Users className="w-6 h-6" data-id="element-237" />,
    title: 'Portugués para RRHH y Consultoría',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-500/20',
    items: 'Entrevistas de trabajo, feedback, evaluaciones de desempeño, y comunicación corporativa interna.'
  }, {
    icon: <GitBranch className="w-6 h-6" data-id="element-238" />,
    title: 'Exportación e Importación',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-500/20',
    items: 'Vocabulario aduanero, logística, incoterms en portugués, y comunicación con proveedores y clientes internacionales.'
  }, {
    icon: <Megaphone className="w-6 h-6" data-id="element-239" />,
    title: 'Comunicación Intercultural',
    color: 'text-green-300',
    bgColor: 'bg-green-500/20',
    items: 'Diferencias culturales en los negocios entre Argentina y Brasil. Cómo interpretar el "jeitinho brasileiro" y evitar malentendidos.'
  }, {
    icon: <ClipboardList className="w-6 h-6" data-id="element-240" />,
    title: 'Plan PRO 60 días + Certificación',
    color: 'text-emerald-300',
    bgColor: 'bg-emerald-600/20',
    items: 'Ruta de estudio acelerada para profesionales. Evaluaciones por módulo y certificado de finalización del Nivel PRO.'
  }, {
    icon: <CalendarHeart className="w-6 h-6" data-id="element-241" />,
    title: 'Scripts de Presentaciones',
    color: 'text-green-300',
    bgColor: 'bg-green-600/20',
    items: 'Plantillas listas para pitches de ventas, presentaciones de resultados, y negociaciones clave con clientes brasileños.'
  }];
  return <section className="py-20 bg-black" data-id="element-242">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-243">
        <div className="text-center mb-12" data-id="element-244">
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[20px]" data-id="element-245">
            🎯 ¿QUÉ AGREGA EL NIVEL PRO?
          </h2>
        </div>

        <div className="mb-16 overflow-x-auto pb-4" data-id="element-246">
          <div className="min-w-[800px]" data-id="element-247">
            <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-248">
              <div className="font-bold text-emerald-300 uppercase text-sm tracking-wider" data-id="element-249">
                Situación
              </div>
              <div className="font-bold text-red-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-250">
                <X className="w-4 h-4" data-id="element-251" /> Sin PRO
              </div>
              <div className="font-bold text-emerald-400 uppercase text-sm tracking-wider flex items-center gap-2" data-id="element-252">
                <Check className="w-4 h-4" data-id="element-253" /> Con PRO
              </div>
            </div>

            <div className="space-y-3" data-id="element-254">
              {comparisons.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-zinc-900/60 rounded-xl p-4 items-center border border-emerald-900/30" data-id="element-255">
                  <div className="font-medium text-white" data-id="element-256">{row.situation}</div>
                  <div className="text-zinc-300 text-sm" data-id="element-257">{row.without}</div>
                  <div className="text-emerald-200 font-medium text-sm bg-emerald-500/15 p-2 rounded-lg border border-emerald-500/30" data-id="element-258">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>
          <p className="text-center text-sm text-emerald-400 mt-4 md:hidden" data-id="element-259">
            ← Scroll to see full table →
          </p>
        </div>

        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 text-white shadow-xl border border-emerald-900/40" data-id="element-260">
          <h3 className="text-2xl font-bold mb-8 flex items-center gap-3 text-white" data-id="element-261">
            <span className="bg-emerald-500 text-white p-1 rounded-full" data-id="element-262">
              <Check className="w-5 h-5" data-id="element-263" />
            </span>
            EL NIVEL PRO INCLUYE:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-264">
            {modules.map((mod, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="bg-black/50 rounded-2xl p-6 border border-emerald-900/30" data-id="element-265">
                <div className="flex items-center gap-3 mb-4" data-id="element-266">
                  <div className={`p-2 rounded-lg ${mod.bgColor} ${mod.color}`} data-id="element-267">
                    {mod.icon}
                  </div>
                  <h4 className="font-bold text-lg text-white" data-id="element-268">{mod.title}</h4>
                </div>
                <p className="text-zinc-200 text-sm leading-relaxed" data-id="element-269">
                  {mod.items}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}